import type { AssetStatusCreateDto, AssetStatusDto, AssetStatusUpdateDto, GetAssetStatusesInput } from './models';
import { RestService } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AssetStatusService {
  apiName = 'Inventory';

  create = (input: AssetStatusCreateDto) =>
    this.restService.request<any, AssetStatusDto>({
      method: 'POST',
      url: '/api/inventory/asset-statuses',
      body: input,
    },
    { apiName: this.apiName });

  delete = (id: string) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/inventory/asset-statuses/${id}`,
    },
    { apiName: this.apiName });

  get = (id: string) =>
    this.restService.request<any, AssetStatusDto>({
      method: 'GET',
      url: `/api/inventory/asset-statuses/${id}`,
    },
    { apiName: this.apiName });

  getList = (input: GetAssetStatusesInput) =>
    this.restService.request<any, PagedResultDto<AssetStatusDto>>({
      method: 'GET',
      url: '/api/inventory/asset-statuses',
      params: { filterText: input.filterText, name: input.name, description: input.description, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName });

  update = (id: string, input: AssetStatusUpdateDto) =>
    this.restService.request<any, AssetStatusDto>({
      method: 'PUT',
      url: `/api/inventory/asset-statuses/${id}`,
      body: input,
    },
    { apiName: this.apiName });

  constructor(private restService: RestService) {}
}
